import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService, ExportTaskProcessor } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { takeUntil } from 'rxjs';
import get from 'lodash-es/get';
import ceil from 'lodash-es/ceil';
import OrderPaymentAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/process/order-payment/order-payment.entity';
import { OrderPaymentAService } from '../order-payment.service';
import { LOCALIZED_PROPERTIES, ORDER_PAYMENT_EXPORT_ID, ORDER_PAYMENT_TITLE } from './order-payment.constants';

@Injectable()
export class OrderPaymentExport {
  constructor(
    private exportService: ExportService,
    private orderpaymentService: OrderPaymentAService,
  ) {}

  private transformItem(item: OrderPaymentAttributes) {
    return {
      route: get(item, 'subRoute.name', '??'),
      user: get(item, 'user.user_login.username', '??'),
      shipToName: get(item, 'shipTo.name', '??'),
      serial: get(item, 'serials', '??'),
      paymentType: get(item, 'paymentType.name', '??'),
      date: ExportTaskProcessor.types.excel.datetime(get(item, 'dateHour', null)),
      bankOperationNumber: get(item, 'bankOperationNumber', '??'),
      bank: get(item, 'bank.name', '??'),
      operationNumber: get(item, 'operationNumber', '??'),
      paying: get(item, 'paying', '??'),
      amount: get(item, 'amount', '??'),
    };
  }

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: ORDER_PAYMENT_EXPORT_ID,
      title: ORDER_PAYMENT_TITLE,
      format: format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      start: (ctx: ExportContext) => {
        ctx.processor.localizeItemProperties(ORDER_PAYMENT_TITLE, LOCALIZED_PROPERTIES)
      },
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.orderpaymentService.findByFilter(buildQuery(
          seed(this.orderpaymentService.currentFilter), page(currentPage, pageSize)
        ), { contextHeader: 'export' }).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).map((item) => {
            ctx.processor.addToSection(ORDER_PAYMENT_TITLE, this.transformItem(item));
          });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(ORDER_PAYMENT_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
